<app-modal [dismissible]="false" class="popup-info-authentication">
    <div *ngIf="displayScanMode && this.modal.isOpen()" appHIDScanner (scannerEvent)="onScan($event)"></div>
    <div class="modal-header"
         modal-header>
        <h5 class="modal-title">{{ title }}</h5>
    </div>
    <div class="modal-body" modal-body *ngIf="displayScanMode">
        <div class="scanner-status">
            <label>Status:</label>
            <span *ngIf="focused"
                  class="message ok">{{ 'generic.scanner.focused' | translate }}</span>
            <span *ngIf="!focused"
                  class="message not-ok">{{ 'generic.scanner.notFocused' | translate }}</span>
        </div>
        <p>{{ missingBoschIdMessage }}</p>
    </div>
    <div class="modal-body" modal-body *ngIf="!displayScanMode">
        <p>{{ missingRoleMessage }}</p>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="onCancel()"
                    [disabled]="isScanninInProgress"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
    </div>
</app-modal>
